import { MenuItem } from '@mui/material';
import { CloneIconOptions, EditIcon } from '../../../../../components/buttons/IconButtons';
import { CustomAddChip } from '../../../../../components/CustomAddChip';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import DividerWithText from '../../../../../components/DividerWithText';
import routes from '../../../../../Routes/routes';
import { militaryHourToTimeString, timeStringToDate } from '../../../../../utils/TimeConversion';
import { DishCategoryEnum, MealTypeEnum } from '../Model/Model';
import ButtonAction from './../../../../../components/buttons/ButtonAction';
import { CustomAddMediumChip } from './../../../../../components/CustomAddMediumChip';
import { CustomDatePicker } from './../../../../../components/CustomDatePicker';
import { CustomTextField } from './../../../../../components/CustomTextField';
import CustomTimePicker from './../../../../../components/CustomTimePicker';
import HeadTittle from './../../../../../components/HeadTittle';
import { permissionObj } from './../../../../../Helpers/permission';
import UpdateMenuApp from './../Functionality/UpdateMenuApp';
import DivContainerBody from '../../../../../components/DivContainerBody';
import React from "react";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UpdateMenu = (props) => {
    const {
        t,
        navigate,
        DEV,
        cloneId,
        item,
        permission,
        disabled,
        emptyFields,
        handleChange,
        handleUpdate,
        selectedName,
        setSelectedName,
        selectedDepartment,
        setSelectedDepartment,
        allMeals,
        allCafeterias,
        allItem,
        selectedMealTime,
        setSelectedMealTime,
        handleMealTimeDelete,
        handleUserDelete,
        handleDepartmentDelete,
        allCourseType,
        emptyDepartment,
        goBack,
        isServingDateValid,
        departments,
        users,
        setDepartment,
        isValidCost,
        validateCost,
        setMealTime,
        mealTime,
        emptyMealTime,
        showCostInfo
    } = UpdateMenuApp(props);

    if(!DEV &&
        !permission?.includes(permissionObj.WEB_FOODIE_MENU_UPDATE) &&
        !permission?.includes(permissionObj.WEB_FOODIE_MENU_CLONE) &&
        !permission?.includes(permissionObj.WEB_FOODIE_MENU_READ))
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
             onBack={goBack}
                name={cloneId ? 'clone' : (!disabled && (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE)) ? 'update' : 'details')}
                link={routes.foodie.list}
            >
                {!cloneId && !disabled && (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE)) && (
                    <ButtonAction
                        id='btn_um_update'
                        className='btn-icon-edit'
                        Icon={EditIcon}
                        name='update'
                        onClick={()=>{
                            validateCost();
                            handleUpdate();
                        }}
                    />
                )}

                {cloneId && (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_CLONE)) && (
                    <ButtonAction
                        id='btn_um_clone'
                        className='btn-icon-add'
                        Icon={CloneIconOptions}
                        name='clone'
                        onClick={()=>{
                            validateCost();
                            handleUpdate();
                        }}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <div className={"row"}>
                    <div className={"col-12 mb-3"}>
                        <DividerWithText title={t('details')} />
                    </div>
                    <div className={"col-12"}>
                        <CustomSelectAndChildren
                            id='slt_um_dish'
                            name='dish'
                            trans='meal'
                            disabled={disabled}
                            value={item?.dish || ''}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                            required={true}
                        >
                            {allItem?.map((meal) => (
                                <MenuItem key={meal.id} value={meal.id}>
                                    {t(meal.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>
                    <div className={"col-12"}>
                        <CustomSelectAndChildren
                            id='slt_um_meal_type'
                            name='mealType'
                            trans='meal_type'
                            disabled={disabled}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            value={item?.mealType || ''}
                            showNoSelectionOption={false}
                            required={true}
                        >
                            {allMeals?.map((meal) => (
                                <MenuItem key={meal.id} value={meal.id}>
                                    {t(MealTypeEnum[meal.id]?.name || '')}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>

                    <div className={"col-12"}>
                        <CustomSelectAndChildren
                            id='slt_um_diner'
                            name='diner'
                            trans='diner'
                            disabled={disabled}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            value={item?.diner || ''}
                            required={true}
                            showNoSelectionOption={false}
                        >
                            {allCafeterias?.map((meal) => (
                                <MenuItem key={meal.id} value={meal.id}>
                                    {t(meal.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>

                    { showCostInfo &&
                        <div className={"col-12"}>
                            <CustomTextField
                                id='txt_um_cost'
                                name='cost'
                                trans="meal_cost"
                                type='number'
                                required={true}
                                onChange={(e)=>{
                                    handleChange(e);
                                    validateCost();
                                }}
                                suffixText={<p className={"ibl-font-w-600 text-uppercase"}>$</p>}
                                inputProps={{
                                    min: 1
                                }}
                                showCounter={true}
                                length={3}
                                value={item?.cost}
                                emptyFields={emptyFields}
                                disabled={disabled}
                                isValid={isValidCost}
                                isValidText={"this_value_must_be_greater_than_0"}
                                helperText={"this_value_must_be_greater_than_0"}
                            />
                        </div>
                    }
                    <div className={'col-12'}>
                         <CustomAddMediumChip
                            autocompleteId='slt_um_service_time'
                            buttonId='btn_um_service_time'
                            disabled={disabled}
                            required={true}
                            label={'service_time'}
                            typeUnit={'stock'}
                            transUnit='stock'
                            unitLength={3}
                            data={mealTime}
                            selectedList={selectedMealTime}
                            setSelectedList={setSelectedMealTime}
                            onSelectItem={(item) => setMealTime((prev) => ({ ...prev, item }))}
                            onChangeUnit={(unit) => setMealTime((prev) => ({ ...prev, unit }))}
                            emptyFields={ emptyMealTime}
                            onDeleteItem={
                                (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE)) ? handleMealTimeDelete : null
                            }
                        />
                    </div>

                    <div className='col-12 mb-3'>
                        <DividerWithText title={t('availability')} />
                    </div>

                    <div className='col-6'>
                        <CustomDatePicker
                            id='dp_um_release_date'
                            name='releaseDate'
                            trans='release_date'
                            value={item?.releaseDate}
                            disablePast={true}
                            openTo='day'
                            required={true}
                            disabled={disabled}
                            onChange={(e) => {
                                handleChange({ target: { value: e, name: 'releaseDate' } });
                            }}
                            emptyFields={emptyFields}
                        />
                    </div>
                    <div className='col-6'>
                        <CustomTimePicker
                            title={t('release_hour')}
                            name='releaseHour'
                            disabled={disabled}
                            emptyFields={emptyFields}
                            inputFormat='HH:mm'
                            handleChange={(value) => handleChange({ target: { name: 'releaseHour', value: value } })}
                            value={
                                item?.releaseHour != null
                                    ? typeof item?.releaseHour === 'number'
                                        ? timeStringToDate(militaryHourToTimeString(item.releaseHour))
                                        : timeStringToDate(item.releaseHour)
                                    : null
                            }
                            required={true}
                            id='tp_um_release_hour'
                            formatValue={true}
                            views={['hours', 'minutes']}
                        />
                    </div>
                    <div className='col-6'>
                        <CustomDatePicker
                            id='dp_um_cafeteria_serving_date'
                            name='cafeteriaServingDate'
                            trans='cafeteria_serving_date'
                            value={item?.cafeteriaServingDate}
                            minDate={item.releaseDate}
                            disablePast={true}
                            openTo='day'
                            required={true}
                            disabled={disabled}
                            isValidText={t('cafeteria_date_must_be_greater')}
                            isValid={isServingDateValid}
                            onChange={(e) => {
                                handleChange({ target: { value: e, name: 'cafeteriaServingDate' } });
                            }}
                            emptyFields={emptyFields}
                        />
                    </div>
                    <div className='col-6'>
                        <CustomSelectAndChildren
                            id={'slt_a_course_type'}
                            name={'courseType'}
                            trans={'course_type'}
                            disabled={disabled}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                            required={true}
                            value={item?.courseType || ''}
                        >
                            {allCourseType?.map((meal) => (
                                <MenuItem key={meal.id} value={meal.id}>
                                    {t(DishCategoryEnum[meal.id]?.name || '')}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>
                    <div className='col-12 mb-3'>
                        <DividerWithText title={t('department_release_delay_priority')} />
                    </div>
                    <div className={"col-12 mb-4"}>
                        <CustomAddMediumChip
                            autocompleteId='slt_um_add_department'
                            buttonId='btn_um_add_department'
                            textFielId='txt_um_department_unit'
                            disabled={disabled}
                            emptyFields={emptyDepartment  }
                            label={'Department'}
                            transUnit="available_after"
                            typeUnit={'time'}
                            unitLength={3}
                            required={false}
                            data={departments}
                            selectedList={selectedDepartment}
                            setSelectedList={setSelectedDepartment}
                            onSelectItem={(item) => setDepartment((prev) => ({ ...prev, item }))}
                            onChangeUnit={(unit) => setDepartment((prev) => ({ ...prev, unit }))}
                            onDeleteItem={
                                (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE)) ? handleDepartmentDelete : null
                            }
                        />
                    </div>

                    <div className='col-12 mb-3'>
                        <DividerWithText title={t('custom_access')} />
                    </div>

                    <div className={'col-12 mb-5'}>
                        <CustomAddChip
                            autocompleteId={'slt_um_employee'}
                            buttonId={'btn_um_add_employee'}
                            label={t('name')}
                            data={users}
                            selectedList={selectedName}
                            setSelectedList={setSelectedName}
                            disabled={disabled}
                            required={false}
                            chipIcon={null}
                            onDeleteItem={  (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE)) ? handleUserDelete : null}
                            reset={false}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default UpdateMenu;
